import { AlertSurgeCooldownEnum } from '../enums/alert-surge-cooldown.enum';

export const alertSurgeCooldownOptions: {label: string; value: AlertSurgeCooldownEnum}[] = [
    {
        label: `Alerts.surge.coolDowns.${AlertSurgeCooldownEnum.HOURS_6}`,
        value: AlertSurgeCooldownEnum.HOURS_6
    },
    {
        label: `Alerts.surge.coolDowns.${AlertSurgeCooldownEnum.HOURS_24}`,
        value: AlertSurgeCooldownEnum.HOURS_24
    },
    {
        label: `Alerts.surge.coolDowns.${AlertSurgeCooldownEnum.DAYS_3}`,
        value: AlertSurgeCooldownEnum.DAYS_3
    },
    {
        label: `Alerts.surge.coolDowns.${AlertSurgeCooldownEnum.DAYS_7}`,
        value: AlertSurgeCooldownEnum.DAYS_7
    },
];
